<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      @resetBtn="resetBtn"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
    <template v-slot:warehouseID>
        <el-select
          multiple
          filterable
          v-model="filters.warehouseID"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in warehouseList"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:changeType>
        <el-select
          multiple
          filterable
          v-model="filters.changeType"
          placeholder="请选择"
          collapse-tags
        >
        </el-select>
      </template>
      <template v-slot:realName>
        <el-select multiple v-model="filters.realName" filterable placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
    </TwTable>

    <!-- 装车单 -->
    <!-- <el-dialog
      id="completeDialog"
      title="移库单"
      :visible.sync="addStockChangeVisible"
      width="90%"
      top="70px"
      style="text-align: center"
    >
      <div id="completeDiv">
        <iframe
          :src="completeTask"
          height="700"
          width="100%"
          style="border: none"
        ></iframe>
      </div>
    </el-dialog> -->
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 29, businessCode: currentRow.loadCarNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>

    <!-- 导入文件 -->
    <el-dialog
      :visible.sync="addStockChangeVisible"
      v-model="addStockChangeVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="导入文件"
      width="40%"
    >
      <el-form :model="addForm">
         <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>仓库：
            <el-select
          filterable
          v-model="addForm.warehouseId"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in warehouseList"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".xls,.xlsx"
              :before-upload="onBeforeUploadExcel"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <el-button type="primary" @click="handleDownload"
              >下载导入模板</el-button
            >
          </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="text-align: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg">
          <span style="color: red"> {{ Importtext }}</span>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<style>
figure {
  page-break-inside: avoid;
}
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
.printTitle {
  font-size: 16px;
  padding-top: 5px;
}

.printTable th,
.printTable td {
  color: #000;
  border-right: 1px solid #000 !important;
  border-bottom: 1px solid #000 !important;
}
</style>
<script>
import { getStockChangeListAsync,importData,downloadTranTemp,downloadTemp,approvedChange } from "@/api/StockChange/index.js";
import { getReadyforTaskBasis } from "@/api/outbound/readyforTask.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
import axios from "axios";
import {getOperatorInfo,} from "@/api/api.js";

export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      userList: [],
      printObj: {
      },
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置

          {
            prop: "stockChangeNo",
            label: "单据编号",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "referenceNo",
            label: "参考单号",
            align: "center",
            sortable: true,
            minWidth: "160",
          },
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "oldStorage",
            label: "旧库位",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "changeQty",
            label: "移库数量",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "newStorage",
            label: "新库位",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "changeStatusText",
            label: "状态",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "remark",
            label: "备注",
            align: "center",
            sortable: true,
            minWidth: "200",
          },
          {
            prop: "operator",
            label: "操作人",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "operatorTime",
            label: "操作时间",
            align: "center",
            sortable: true,
            minWidth: "140",
          },
        ],
      },
      addStockChangeVisible: false,
      completeTask: "/StorageChange/AddStorageChange",
      searchData: {
        //搜索列配置
        search: [
          {
            type: "input",
            key: "stockChangeNo",
            label: "单据号",
            placeholder: "多个单据号用逗号分开查询",
            clearable: true,
            width:200,
          },
          {
            type: "input",
            key: "referenceNo",
            label: "参考单号",
            placeholder: "多个参考单号用逗号分开查询",
            clearable: true,
             width:200,
          },
          {
            type: "select",
            key: "warehouseID",
            prop: "warehouseID",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择",
            option: this.warehouseList,
          },
           {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      buttonList: [],
      warehouseList: [],
      Importtext:"",
      progressPercent:0,
      progressFlag:true,
      addForm: {
        warehouseId:2,
      },
    };
  },

  created() {
    // 监听子组件的关闭事件
    window.addEventListener(
      "message",
      () => {
        this.closeSelf();
        this.closeReviewdialogVisible();
      },
      false
    );
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    
    //文件上传前验证
    onBeforeUploadExcel(file) {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }

      return extension || extension2;
    },
    //上传文件
    UploadExcel(param) {
      console.log(param, "文件");
      let para = new FormData();
      para.append("file", param.file);
      this.progressFlag = true;
      var _this = this;
      axios({
        url: importData+'?warehouseID='+this.addForm.warehouseId,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          // progressEvent.loaded:已上传文件大小
          // progressEvent.total:被上传文件的总大小
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.Importtext = res.data.msg;
          console.log(this.Importtext);
          if (res.data.success) {
            console.log("导入成功");
            param.onError(); // 上传成功的文件会显示绿色的对勾
            this.importVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getReportlist();
          } else {
            // this.$message({
            //   message: res.data.msg,
            //   type: "error",
            // });
            param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },
    //下载模板
    handleDownload() {
      let url = this.addForm.warehouseId==2? downloadTranTemp:downloadTemp;
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      document.body.appendChild(link);
      link.click();
    },
    closeSelf() {
      // 关闭当前弹框
      this.addStockChangeVisible = false;
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    // 弹出添加移库单
    addTaskdialog() {
      this.addStockChangeVisible = true;
    },

    ApprovedData(){
       let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择数据！",
          type: "error",
        });
        return;
      }
      var that = this;
      approvedChange({ stockChangeInfoIDs: row[0].stockChangeInfoID }).then(
        (res) => {
          if (res.data.success) {
            this.initTable();
            this.printPickListVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    //查询列表
    initTable() {
      const {
        stockChangeNo,
        referenceNo,
        changeType,
        warehouseID,
        realName,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        changeTypes: thereAre(changeType),
        warehouseIDs: thereAre(warehouseID),
        realName:thereAre(realName),
        stockChangeNo,
        referenceNo,
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getStockChangeListAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = user.warehouseList;
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
    this.getBasicdatalist();
    getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });
  },
};
</script>

<style lang="less">
.content-az {
  overflow-x: hidden;
}
.dialogClass {
  .el-dialog {
    .el-dialog__body {
      //border-top: 1px solid #dcdfe6;
      //border-bottom: 1px solid #dcdfe6;
      max-height: 2000px !important;
      min-height: 500px;
      overflow-y: hidden;
    }
  }
  .el-dialog.is-fullscreen {
    max-height: 2000px !important;
    min-height: 500px;
  }
}
</style>
<style type="text/css" media="print">
@page {
  margin-top: 5mm;
  margin-bottom: 9mm;
  padding-top: 5mm;
}
@media print {
  div.content {
    page-break-after: always;
  }
}
</style>